import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useConvites } from '../context';
import { formatarPeriodo } from '@/pages/evento/utils';
import type { Convite } from '../types';

export default function CartaoConvite({ convite }: { convite: Convite }) {
  const navigate = useNavigate();
  const { aceitar, recusar } = useConvites();
  const [aceitando, setAceitando] = useState(false);
  const [recusando, setRecusando] = useState(false);
  const [confirmando, setConfirmando] = useState(false);
  const [erro, setErro] = useState<string | null>(null);

  const periodo = formatarPeriodo(convite.inicio_em, convite.fim_em ?? convite.inicio_em);
  const lugar = [convite.local_nome, convite.cidade].filter(Boolean).join(', ');

  async function aoAceitar() {
    setAceitando(true);
    setErro(null);
    const msg = await aceitar(convite.evento_id);
    if (msg) {
      setErro(msg);
      setAceitando(false);
      return;
    }
    navigate(`/gerenciar/${convite.evento_id}`);
  }

  async function aoRecusar() {
    setConfirmando(false);
    setRecusando(true);
    setErro(null);
    const msg = await recusar(convite.evento_id);
    setRecusando(false);
    if (msg) setErro(msg);
  }

  return (
    <div className="rounded-lg border border-secondary-200 bg-white p-4">
      <div className="flex items-start gap-3">
        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-primary-100 text-primary-600">
          <i className="ri-mail-line text-lg" />
        </span>
        <div className="min-w-0 flex-1">
          <p className="text-[15px] font-medium leading-snug text-foreground-950">
            Convite · {convite.evento}
          </p>
          <p className="mt-0.5 text-sm text-secondary-500">
            {convite.convidado_por} convidou você para administrar
          </p>
          {(periodo || lugar) && (
            <p className="mt-0.5 text-xs text-secondary-400">
              {[periodo, lugar].filter(Boolean).join(' · ')}
            </p>
          )}
        </div>
      </div>

      {confirmando ? (
        <div className="mt-3 rounded-md border border-amber-300 bg-amber-50 px-3 py-2.5">
          <p className="text-sm text-amber-800">
            Recusar o convite? Quem convidou vai ver que você não aceitou.
          </p>
          <div className="mt-2 flex items-center gap-2">
            <button
              type="button"
              onClick={aoRecusar}
              disabled={recusando}
              className="cursor-pointer whitespace-nowrap rounded-md bg-amber-600 px-4 py-1.5 text-sm font-medium text-white transition-colors hover:bg-amber-700 disabled:cursor-not-allowed disabled:opacity-60"
            >
              {recusando ? 'Recusando…' : 'Recusar'}
            </button>
            <button
              type="button"
              onClick={() => setConfirmando(false)}
              disabled={recusando}
              className="cursor-pointer whitespace-nowrap text-sm font-medium text-secondary-500 transition-colors hover:text-foreground-800 disabled:cursor-not-allowed"
            >
              Cancelar
            </button>
          </div>
        </div>
      ) : (
        <div className="mt-3 flex items-center gap-2">
          <button
            type="button"
            onClick={aoAceitar}
            disabled={aceitando}
            className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-60"
          >
            {aceitando ? 'Aceitando…' : 'Aceitar'}
          </button>
          <button
            type="button"
            onClick={() => setConfirmando(true)}
            disabled={aceitando}
            className="cursor-pointer whitespace-nowrap rounded-md border border-secondary-300 bg-white px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 disabled:cursor-not-allowed disabled:opacity-60"
          >
            Recusar
          </button>
        </div>
      )}

      {erro && <p className="mt-2 text-sm text-danger-600">{erro}</p>}
    </div>
  );
}